let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c6xj7")).then(() => parcelRequire('3STzC'));